import {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  parsePhoneNumber,
} from "react-phone-number-input";

export const formatFrenchPhoneNumber = (phone: string) => {
  // Use french format as default but accept internationals numbers
  const phoneNumber = parsePhoneNumber(phone, "FR");
  if (!phoneNumber) return null;
  return formatPhoneNumber(phoneNumber.number);
};

export const formatToGlobalPhoneNumber = (phone: string) => {
  // Use french format as default but accept internationals numbers
  const phoneNumber = parsePhoneNumber(phone, "FR");
  if (!phoneNumber) return null;
  return formatPhoneNumberIntl(phoneNumber.number);
};
